import React from 'react'

const Wrapper = (props) => {
  return (
    <div className=' w-screen h-screen bg-[#0C1717]'>{props.children}</div>
  )
}

export default Wrapper